var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.727 6.727H14V0H4.91C4.005 0 3.273 0.732 3.273 1.636V22.364C3.273 23.268 4.005 24 4.909 24H19.091C19.995 24 20.727 23.268 20.727 22.364V6.727H14.727ZM14.182 17.182H7.09V15.818H14.18V17.182H14.182ZM16.909 13.909H7.091V12.545H16.909V13.909ZM16.909 10.636H7.091V9.273H16.909V10.636ZM14.727 6H20.727L14.727 0V6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.7a390b88d107a408431efd72919cc424.svg";
export { ForwardRef as ReactComponent };